/* Salon Cocon · animations et compte à rebours (JavaScript sans bibliothèque, pour Dawn) */
(function () {
  var reduce = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;
  var canAnimate = !reduce && 'IntersectionObserver' in window;
  var io = null;

  /* ---------- compte à rebours honnête : cible la vraie date de fin, se cache après ---------- */
  function pad(n) { return (n < 10 ? '0' : '') + n; }
  function tick() {
    document.querySelectorAll('[data-cc-countdown]').forEach(function (el) {
      var end = Date.parse(el.getAttribute('data-cc-countdown'));
      var out = el.querySelector('.cc-cd-time');
      if (isNaN(end) || !out) { el.hidden = true; return; }
      var s = Math.floor((end - Date.now()) / 1000);
      if (s <= 0) { el.hidden = true; return; }
      el.hidden = false;
      var d = Math.floor(s / 86400), h = Math.floor(s % 86400 / 3600), m = Math.floor(s % 3600 / 60), sec = s % 60;
      out.textContent = (d > 0 ? d + ((document.documentElement.lang || '').indexOf('es') === 0 ? ' d ' : ' j ') : '') + pad(h) + ' h ' + pad(m) + ' min ' + pad(sec) + ' s';
    });
  }
  tick(); setInterval(tick, 1000);

  if (!canAnimate) return;
  var designMode = window.Shopify && Shopify.designMode;
  document.documentElement.classList.add('ca-ready');

  function countUp(el) {
    var to = +el.dataset.caCount, from = +(el.dataset.caFrom || 0), t0 = performance.now();
    function step(t) { var k = Math.min(1, (t - t0) / 1200); el.textContent = Math.round(from + (to - from) * (1 - Math.pow(1 - k, 3))); if (k < 1) requestAnimationFrame(step); }
    requestAnimationFrame(step);
  }
  io = new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      if (!e.isIntersecting) return;
      e.target.classList.add('ca-in'); io.unobserve(e.target);
      e.target.querySelectorAll('[data-ca-count]').forEach(countUp);
    });
  }, { threshold: 0.15, rootMargin: '0px 0px -40px 0px' });

  function init(root) {
    var groups = new Map();
    root.querySelectorAll('.ca-reveal, .ca-wipe').forEach(function (el) {
      var k = el.parentElement, i = groups.get(k) || 0; groups.set(k, i + 1);
      if (!el.style.getPropertyValue('--ca-d')) el.style.setProperty('--ca-d', Math.min(i, 5) * 0.1 + 's');
      // dans l'éditeur de thème, tout reste visible
      if (designMode) el.classList.add('ca-in'); else io.observe(el);
    });
    root.querySelectorAll('.ca-words').forEach(function (el) {
      if (el.dataset.caDone) return; el.dataset.caDone = '1';
      el.setAttribute('aria-label', el.textContent.trim());
      el.innerHTML = el.textContent.trim().split(/\s+/).map(function (w, i) { return '<span class="ca-w" aria-hidden="true" style="--i:' + i + '">' + w + '</span>'; }).join(' ');
    });
    root.querySelectorAll('.ca-stagger').forEach(function (l) { [].forEach.call(l.children, function (c, i) { c.style.setProperty('--i', i); }); });
    root.querySelectorAll('.ca-float').forEach(function (el, i) { el.style.setProperty('--i', i); });
    if (matchMedia('(hover: hover) and (pointer: fine)').matches) {
      root.querySelectorAll('.ca-tilt').forEach(function (el) {
        el.addEventListener('mousemove', function (e) {
          var r = el.getBoundingClientRect(), x = (e.clientX - r.left) / r.width - .5, y = (e.clientY - r.top) / r.height - .5;
          el.classList.add('ca-tilting');
          el.style.transform = 'perspective(900px) rotateX(' + (-y * 6) + 'deg) rotateY(' + (x * 6) + 'deg) translateY(-4px)';
        });
        el.addEventListener('mouseleave', function () { el.classList.remove('ca-tilting'); el.style.transform = ''; });
      });
      root.querySelectorAll('.ca-magnet').forEach(function (el) {
        el.addEventListener('mousemove', function (e) {
          var r = el.getBoundingClientRect();
          el.style.transform = 'translate(' + ((e.clientX - r.left - r.width / 2) * .18) + 'px,' + ((e.clientY - r.top - r.height / 2) * .3) + 'px)';
        });
        el.addEventListener('mouseleave', function () { el.style.transform = ''; });
      });
    }
  }
  init(document);
  // l'éditeur de thème recharge une section quand on la modifie
  document.addEventListener('shopify:section:load', function (e) { init(e.target); tick(); });

  // légère parallaxe sur la grande image d'accueil
  var par = document.querySelector('[data-ca-parallax]');
  if (par && matchMedia('(min-width: 761px)').matches) addEventListener('scroll', function () { var y = Math.min(scrollY, 900); par.style.transform = 'translateY(' + (y * 0.18) + 'px)'; }, { passive: true });

  // barre de progression de lecture
  var bar = document.createElement('div'); bar.className = 'ca-progress'; bar.setAttribute('aria-hidden', 'true'); document.body.appendChild(bar);
  function prog() { var m = document.documentElement.scrollHeight - innerHeight; bar.style.transform = 'scaleX(' + (m > 0 ? scrollY / m : 0) + ')'; }
  addEventListener('scroll', prog, { passive: true }); addEventListener('resize', prog); prog();
})();

/* Salon Cocon : textes écrits dans le thème, traduits en espagnol sur /es/ (les autres textes passent par Translate & Adapt) */
(function () {
  if ((document.documentElement.lang || '').indexOf('es') !== 0) return;
  var EX = {
"Plateau": "Tablero",
"Rangement": "Almacenamiento",
"Structure": "Estructura",
"Pieds": "Patas",
"Finition": "Acabado",
"Dimensions fermée (L × P × H)": "Dimensiones cerrada (L × P × A)",
"Dimensions relevée (L × P × H)": "Dimensiones elevada (L × P × A)",
"Compartiments latéraux (chacun)": "Compartimentos laterales (cada uno)",
"Compartiment central": "Compartimento central",
"Charge maximale totale": "Carga máxima total",
"Charge maximale du plateau": "Carga máxima del tablero",
"Montage": "Montaje",
"Expédiée depuis": "Enviado desde",
"Rangement caché (L × P × H)": "Almacenamiento oculto (L × P × A)",
"Compartiments inférieurs (chacun)": "Compartimentos inferiores (cada uno)",
"Charge maximale du plateau relevé": "Carga máxima del tablero elevado",
"Charge maximale par compartiment": "Carga máxima por compartimento",
"Façade": "Frente",
"Élévation du plateau": "Elevación del tablero",
"Hauteur des pieds": "Altura de las patas",
"Référence fournisseur": "Referencia del proveedor",
"Dimensions relevée indiquées (L × P × H)": "Dimensiones elevada indicadas (L × P × A)",
"Hauteur relevée": "Altura elevada",
"Charge maximale recommandée": "Carga máxima recomendada",
"Grand plateau": "Tablero grande",
"Petit plateau": "Tablero pequeño",
"Hauteur des plateaux relevés": "Altura de los tableros elevados",
"Hauteur du caisson": "Altura del cuerpo",
"Grand plateau (L × P)": "Tablero grande (L × P)",
"Petit plateau (L × P)": "Tablero pequeño (L × P)",
"relevable": "elevable",
"3 compartiments cachés sous le plateau": "3 compartimentos ocultos bajo el tablero",
"panneaux mélaminés": "paneles melamínicos",
"pin, évasés": "pino, inclinadas",
"décor bois et blanc": "decoración madera y blanco",
"assemblage requis": "requiere montaje",
"Espagne": "España",
"relevable, gris effet marbre": "elevable, gris efecto mármol",
"compartiment caché et étagère ouverte": "compartimento oculto y estante abierto",
"blanc et gris effet marbre": "blanco y gris efecto mármol",
"2 compartiments cachés": "2 compartimentos ocultos",
"rainurée, effet chêne": "acanalado, efecto roble",
"métal noir": "metal negro",
"assemblage requis, 1 personne recommandée": "requiere montaje, se recomienda 1 persona",
"relevable, fermeture douce": "elevable, cierre suave",
"panneaux imitation bois et cadre en métal": "paneles imitación madera y marco de metal",
"décor bois clair et métal noir": "decoración madera clara y metal negro",
"réglables pour les sols irréguliers": "regulables para suelos irregulares",
"France": "Francia",
"environ 74,9 × 50 cm (29,5 × 19,7 pouces)": "aprox. 74,9 × 50 cm",
"environ 45 × 50 cm (17,7 × 19,7 pouces)": "aprox. 45 × 50 cm",
"environ 62 cm (24,4 pouces)": "aprox. 62 cm",
"environ 47 cm (18,5 pouces), hors plateaux relevés": "aprox. 47 cm, sin contar los tableros elevados",
"Épuisé pour le moment.": "Agotado por el momento.",
"Coup de cœur": "Favorito",
"Offre d'automne : fin dans": "Oferta de otoño: termina en",
"🎁 Cadeau débloqué": "🎁 Regalo desbloqueado",
"Lampe de bureau LED": "Lámpara de escritorio LED",
"Lampadaire globe pied doré": "Lámpara de pie globo dorada",
"au lieu de 59 €": "en lugar de 59 €",
"au lieu de 99 €": "en lugar de 99 €",
"Appliquer l'offre": "Aplicar la oferta",
"+ Ajouter": "+ Añadir",
"Lampe de bureau LED à 29 € avec votre table.": "Lámpara de escritorio LED a 29 € con tu mesa.",
"Lampadaire globe pied doré à 69 € avec votre table.": "Lámpara de pie globo con base dorada a 69 € con tu mesa.",
"Elle arrive dans un colis séparé.": "Llega en un paquete aparte.",
"Il arrive dans un colis séparé.": "Llega en un paquete aparte.",
"Lampe de bureau à 29 € avec votre table": "Lámpara de escritorio a 29 € con tu mesa",
"Lampadaire globe à 69 € avec votre table": "Lámpara de pie globo a 69 € con tu mesa",
"Vous économisez": "Ahorras",
"Livraison offerte": "Envío gratuito",
"France et Espagne": "España y Francia",
"Retours": "Devoluciones",
"14 jours": "14 días",
"Paiement": "Pago",
"100 % sécurisé": "100 % seguro",
"Nos collections": "Nuestras colecciones",
"Tables relevables": "Mesas elevables",
"Lumière": "Luz",
"Livraison offerte en France et en Espagne": "Envío gratuito en España y Francia",
"14 jours pour changer d'avis": "14 días para cambiar de opinión",
"Paiement 100 % sécurisé": "Pago 100 % seguro",
"Une question ?": "¿Alguna pregunta?",
"Écrivez-nous, réponse rapide par e-mail": "Escríbenos, respuesta rápida por correo",
"Service client": "Atención al cliente",
"Par e-mail · réponse rapide": "Por correo · respuesta rápida",
"Par téléphone": "Por teléfono",
"Adresse": "Dirección",
"En France et en Espagne.": "En España y Francia.",
"Écrivez-nous avec votre numéro de commande.": "Escríbenos con tu número de pedido.",
"Carte bancaire et moyens de paiement Shopify.": "Tarjeta bancaria y medios de pago de Shopify.",
"Merci, votre message est bien envoyé. Nous vous répondons très vite par e-mail.": "Gracias, tu mensaje se ha enviado. Te responderemos muy pronto por correo.",
"Merci, votre question est bien envoyée. Nous vous répondons très vite par e-mail.": "Gracias, tu pregunta se ha enviado. Te responderemos muy pronto por correo.",
"Vérifiez votre adresse e-mail et votre message.": "Revisa tu correo electrónico y tu mensaje.",
"Nom et prénom": "Nombre y apellidos",
"Prénom": "Nombre",
"E-mail *": "Correo electrónico *",
"Numéro de téléphone": "Teléfono",
"N° de commande": "N.º de pedido",
"(facultatif)": "(opcional)",
"Votre message *": "Tu mensaje *",
"Votre question *": "Tu pregunta *",
"Envoyer mon message": "Enviar mi mensaje",
"Envoyer ma question": "Enviar mi pregunta",
"* Champs obligatoires. Vos données servent uniquement à vous répondre.": "* Campos obligatorios. Tus datos solo se usan para responderte.",
"Avant": "Antes",
"Ajouter au panier": "Añadir al carrito",
"Voir la table": "Ver la mesa"
};
  var PH = [["ou 3 paiements de ", "o 3 pagos de "], [" avec Klarna", " con Klarna"], [" avec le coupon", " con el cupón"], [" au lieu de ", " en lugar de "], [" la pièce)", " la unidad)"], ["(1 pièce)", "(1 unidad)"], ["Votre table vous offre ", "Tu mesa te regala "], [" sur une des lumières", " en una de las lámparas"], ["Choisissez ", "Elige "], [" lumière à prix doux (facultatif) :", " lámpara a precio especial (opcional):"], ["Coupon de ", "Cupón de "], [" € appliqué", " € aplicado"], ["Appliquer mon coupon de ", "Aplicar mi cupón de "], ["Après · ", "Después · "], ["Voir toute la collection", "Ver toda la colección"]];
  var AT = {"Votre question sur une table, une lampe, une livraison…": "Tu pregunta sobre una mesa, una lámpara, un envío…", "Glisser pour comparer avant et après": "Desliza para comparar antes y después"};
  var SEL = '.cc-spec, .cc-klarna, .cc-deliv, .cc-best, .cc-card-coupon, .cc-upsell, .cc-unit-price, .cc-countdown, .cc-gift, .cc-savings, .cc-savings__detail, .cc-cart-coupon, .cc-ctrust, .cc-mdx, .cc-contact, .cc-question, .cc-cmp, .cc-oc, .cc-satc, .cc-rail__all';
  function fixText(n) {
    var v = n.nodeValue, t = v.trim();
    if (!t) return;
    if (EX[t] != null) { n.nodeValue = v.replace(t, EX[t]); return; }
    var o = v;
    for (var i = 0; i < PH.length; i++) if (o.indexOf(PH[i][0]) > -1) o = o.split(PH[i][0]).join(PH[i][1]);
    if (o !== v) n.nodeValue = o;
  }
  function fixDates(root) {
    root.querySelectorAll('.cc-deliv[data-max]').forEach(function (u) {
      var a = +u.dataset.min, b = +u.dataset.max, r = u.querySelector('.cc-deliv-range');
      if (!b || !r || r.dataset.es) return;
      var f = function (n) { var d = new Date(); d.setDate(d.getDate() + n); return d.toLocaleDateString('es-ES', { day: 'numeric', month: 'short' }); };
      r.textContent = f(a) + ' y el ' + f(b); r.dataset.es = '1';
    });
  }
  function run(root) {
    var boxes = root.matches && root.matches(SEL) ? [root] : [];
    root.querySelectorAll && root.querySelectorAll(SEL).forEach(function (b) { boxes.push(b); });
    boxes.forEach(function (b) {
      var w = document.createTreeWalker(b, NodeFilter.SHOW_TEXT, null), n;
      while ((n = w.nextNode())) fixText(n);
      b.querySelectorAll('[placeholder],[aria-label]').forEach(function (e) {
        ['placeholder', 'aria-label'].forEach(function (k) { var v = e.getAttribute(k); if (v && AT[v]) e.setAttribute(k, AT[v]); });
      });
    });
    if (root.querySelectorAll) fixDates(root);
  }
  run(document.body);
  var busy = false;
  new MutationObserver(function (list) {
    if (busy) return; busy = true;
    list.forEach(function (m) {
      m.addedNodes.forEach(function (n) { if (n.nodeType === 1) run(n); else if (n.nodeType === 3 && n.parentElement && n.parentElement.closest(SEL)) fixText(n); });
      if (m.type === 'characterData' && m.target.parentElement && m.target.parentElement.closest(SEL)) fixText(m.target);
    });
    busy = false;
  }).observe(document.body, { childList: true, subtree: true, characterData: true });
})();
